import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const MARK_HOLIDAY = 'MARK_HOLIDAY';
export const MARK_HOLIDAY_SUCCESS = 'MARK_HOLIDAY_SUCCESS';
export const MARK_HOLIDAY_FAILURE = 'MARK_HOLIDAY_FAILURE';

// Action Creators
export const markHoliday = () => ({
  type: MARK_HOLIDAY,
});

export const markHolidaySuccess = (users) => ({
  type: MARK_HOLIDAY_SUCCESS,
  payload: users,
});

export const markHolidayFailure = (error) => ({
  type: MARK_HOLIDAY_FAILURE,
  payload: error,
});

// Thunk Function
export const markHolidayCallAPI = (external, body) => {
  return async (dispatch) => {
    dispatch(markHoliday());
    try {
      const response = await postMethodWithToken(url?.markHoliday, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(markHolidaySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(markHolidayFailure(error?.message));
    }
  };
};
